/* PARCU - the subcategory bar, corrected.

   parcu-header.js builds that bar from two fixed nav sources: the
   tees family contributes its dropdown links, the hoodies family
   contributes its own top level link. That held while hoodies was
   a plain link. Once it gained a dropdown in Shopify's navigation
   the theme rendered it as a details whose summary holds no anchor,
   the "take the top level link" lookup found nothing, and the entry
   dropped out of the bar entirely.

   The bar is deliberately the same on every collection, hoodie
   collections included: the tee categories, with each other family
   sitting among them as a single link, so the row never changes
   shape under you as you move about the shop. The hoodie colours
   live in the menu, not here.

   Position is deliberate too. The other families go in at AFTER,
   which puts Heavyweight Hoodies directly after New Arrivals rather
   than trailing at the end of the colours.

   This runs after parcu-header.js and rewrites what it built,
   rather than replacing it: if this file ever stops matching, the
   theme's own bar is still there underneath. */
(function () {
    'use strict';

    /* The family whose children fill the bar. */
    var CHILD_FAMILY = 'Heavyweight tees';
    /* The families that appear in it as a single link, in order. */
    var LINK_FAMILIES = ['Heavyweight Hoodies'];
    /* Where those single links go: after All, Best Sellers and New
       Arrivals, before the colours start. */
    var AFTER = 3;

    function norm(p) { return (p || '').replace(/\/$/, ''); }
    function linkOf(a) {
        var href = a && a.getAttribute('href');
        var text = a && a.textContent.trim();
        return (href && text) ? { href: href, text: text } : null;
    }

    function findFamily(nav, want) {
        var wanted = want.toLowerCase(), found = null;
        Array.prototype.forEach.call(nav.children, function (li) {
            var head = li.querySelector(':scope > a, :scope > details > summary');
            if (!head || head.textContent.trim().toLowerCase() !== wanted) return;
            var label = head.textContent.trim();
            var kids = [];
            Array.prototype.forEach.call(li.querySelectorAll('ul a'), function (a) {
                var l = linkOf(a);
                if (l) kids.push(l);
            });
            /* A top level entry with no dropdown is a plain anchor;
               one with a dropdown is a details whose summary holds
               no anchor, so its own link is the first entry of the
               dropdown, its All. */
            var own = linkOf(li.querySelector(':scope > a'))
                || linkOf(li.querySelector(':scope > details > summary a'));
            var home = own ? { href: own.href, text: label }
                : (kids.length ? { href: kids[0].href, text: label } : null);
            found = { label: label, home: home, children: kids };
        });
        return found;
    }

    function wanted() {
        var nav = document.querySelector('#headerGrid .menu nav > ul');
        if (!nav) return null;

        var base = findFamily(nav, CHILD_FAMILY);
        if (!base || base.children.length < 2) return null;

        var links = base.children.slice();
        var at = Math.min(AFTER, links.length);
        LINK_FAMILIES.forEach(function (name) {
            var fam = findFamily(nav, name);
            if (!fam || !fam.home) return;
            var dup = false;
            links.forEach(function (l) { if (l.href === fam.home.href) dup = true; });
            if (dup) return;
            links.splice(at, 0, fam.home);
            at += 1;
        });

        window.PARCU_SUBFAM = { label: base.label, href: base.home ? base.home.href : '' };
        return links;
    }

    function same(bar, links) {
        var as = bar.querySelectorAll('a');
        if (as.length !== links.length) return false;
        for (var i = 0; i < as.length; i++) {
            if (as[i].getAttribute('href') !== links[i].href) return false;
            if (as[i].textContent.trim() !== links[i].text) return false;
        }
        return true;
    }

    function apply() {
        var bar = document.querySelector('.parcu-subbar');
        if (!bar) return;
        var links = wanted();
        if (!links || links.length < 2) return;
        /* Idempotent, so the observer below settles instead of
           looping, and a late translation pass is not undone. */
        if (same(bar, links)) return;

        var ul = bar.querySelector('ul') || bar.appendChild(document.createElement('ul'));
        var here = norm(location.pathname);
        ul.textContent = '';
        links.forEach(function (l) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = l.href;
            a.textContent = l.text;
            if (norm(l.href) === here) a.setAttribute('aria-current', 'page');
            li.appendChild(a);
            ul.appendChild(li);
        });
    }

    function start() {
        apply();
        if (!window.MutationObserver) return;
        var t;
        new MutationObserver(function () { clearTimeout(t); t = setTimeout(apply, 80); })
            .observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else { start(); }
})();
